import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilCallback, useRecoilValue } from 'recoil';

import { currentTransState } from '../../../atoms';
import { clearGiftCardSelection } from '../../../domains/Checkout/slice';
import Button from '../../../GlobalComponents/Button';
import { Flex } from '../../../GlobalComponents/Flex';
import { useAppDispatch } from '../../../reduxstore/hooks';
import { isCheckoutLoadingState, sendOrderErrorState } from '../../atoms';
import { Heading } from '../../components/Heading';
import { OrderInfo } from '../../components/OrderInfo';

export const PaymentOption: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const currentTrans = useRecoilValue(currentTransState);
	const onSelectPaymentType = (type: 'GIFT_CARD' | 'STRIPE') => {
		navigate('../payment', { state: { type } });
	};

	const resetState = useRecoilCallback(({ reset }) => () => {
		reset(sendOrderErrorState);
		reset(isCheckoutLoadingState);
	});

	useEffect(() => {
		resetState();
		dispatch(clearGiftCardSelection(Number(currentTrans?.total) || 0));
	}, [currentTrans?.total, dispatch, resetState]);

	return (
		<div className="checkout-payment w-100">
			<OrderInfo />
			<Flex
				$flexDirection="column"
				$height="fit-content"
				$padding="16px 0 0 0"
				style={{
					borderTop: '1px solid #d9d9d9'
				}}
			>
				<Heading $fontSize="24px">Select Payment Method</Heading>

				<Flex
					$flexDirection="column"
					$rowGap="10px"
					$padding="10px 0 26px"
				>
					<Button
						$width="100%"
						onClick={() => onSelectPaymentType('GIFT_CARD')}
					>
						BIGGBY CARD
					</Button>

					<Button
						$width="100%"
						onClick={() => {
							onSelectPaymentType('STRIPE');
						}}
					>
						CREDIT CARD/MOBILE PAY
					</Button>
				</Flex>

				<Button
					$width="100%"
					$border="1px solid #574D45"
					$backgroundColor="#574D45"
					$color="#FDFDFD"
					onClick={() => {
						navigate('../pickup');
					}}
				>
					BACK
				</Button>
			</Flex>
		</div>
	);
};
